// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__9097n","title":"Header_title__Z4P2B","left":"Header_left__3pWy8","clinicName":"Header_clinicName__3BDFn"};